import { X } from "lucide-react";
import { useEffect, useState } from "react";

export const MyGamePreview = ({
  isOpen,
  onClose,
  gameUrl,
}) => {
   const [iframeKey, setIframeKey] = useState(0);
    useEffect(() => {
    if (isOpen) {
      setIframeKey((k) => k + 1);
    }
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-4 -right-4 z-10 bg-white rounded-full p-2 shadow-lg"
        >
          <X size={20} />
        </button>

        {/* Phone Frame */}
        <div className="relative w-[360px] h-[740px] bg-slate-200 rounded-[40px] p-3 shadow-2xl">
          {/* Notch */}
          <div className="absolute top-5 left-1/2 -translate-x-1/2 w-32 h-4 bg-slate-200 rounded-full z-10" />

          {/* Screen */}
          <div className="w-full h-full  rounded-[32px] bg-white">
            <iframe
              key={iframeKey}
              src={gameUrl}
              title="Game Preview"
              className="w-full h-full border-0 rounded-4xl"
              allow="fullscreen"
              
            />
          </div>
        </div>
      </div>
     
    </div>
  );
};